import { toastStore, type ActionItem } from 'shared/ui'
import { writeTextToClipboard, logger } from 'shared/lib'
import { type RowPendingClient } from 'entities/Clients/model/RowPendingClient'
import { ClientsApi } from 'entities/Clients/api/clients'
import { cancelInvite } from 'pages/clients/ui/actions/cancelInvite/cancelInvite'

export const getPendingClientRowActions = (
  row: RowPendingClient,
  onSuccessCancelInvite: () => void
): ActionItem[] => {
  return [
    {
      text: 'Copy invite link',
      icon: 'copy',
      onAction: () => {
        writeTextToClipboard(row.url)

        toastStore.add({
          type: 'info',
          title: 'Copied',
        })
      },
    },
    {
      text: 'Resend invite',
      icon: 'back',
      onAction: async () => {
        try {
          await ClientsApi.resendInvite(row.origin.id)
          toastStore.add({
            type: 'info',
            title: 'Invite resent',
          })
        } catch (error) {
          logger.error(error)
          toastStore.add({
            type: 'error',
            title: 'Something went wrong, try again.',
          })
        }
      },
    },

    {
      text: 'Cancel invite',
      icon: 'delete',
      onAction: () => cancelInvite(row, onSuccessCancelInvite),
    },
  ]
}
